<template>
  <section id="chatWidget">
    <chat-button @showChatChannels="showChatChannels" />
    <chat-channels
      v-show="isChannels"
      class="custom-channels"
      @showMessages="showMessages"
      @closeChannels="closeChannels"
    />
    <chat-messages
      v-show="isChat"
      :channelId="channelId"
      class="custom-chat"
      @closeMessages="closeMessages"
      @minimizeMessages="minimizeMessages"
    />
    <chat-bar @showMessages="showMessages" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ChatButton from '@/components/chat/chat-button'
import ChatMessages from '@/components/chat/chat-messages'
import ChatChannels from '@/components/chat/chat-groups'
import ChatBar from '@/components/chat/chat-bar'
export default {
  name: 'chat-widget',
  components: {
    ChatButton,
    ChatMessages,
    ChatChannels,
    ChatBar
  },
  data() {
    return {
      isChat: false,
      isChannels: false,
      channelId: 0
    }
  },
  mounted() {
    this.isChat = false
    this.isChannels = false
    this.channel = 0
    this.init()
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('calibrates', ['calibrateEvent']),
    ...mapGetters('chat', ['pubnub'])
  },
  methods: {
    ...mapActions('chat', [
      'initChat',
      'resetMessages',
      'resetChannelInfo',
      'getChannels',
      'getChannelInfo',
      'getChannelMessages',
      'quitChat',
      'setChatBar'
    ]),
    ...mapActions('calibrates', ['getCalibrateEvent']),
    closeChannels() {
      this.isChannels = false
    },
    closeMessages() {
      // remove from Chat Bar
      let data = {
        name: 'remove',
        value: this.channelId
      }
      this.setChatBar(data)
      this.isChat = false
      this.channelId = 0
      this.isChannels = true
      this.resetChannelInfo()
    },
    minimizeMessages() {
      // add to Chat Bar
      let data = {
        name: 'add',
        value: this.channelId
      }
      this.setChatBar(data)
      this.isChat = false
      this.channelId = 0
      this.isChannels = true
      this.resetChannelInfo()
    },
    showChatChannels() {
      if (this.isChat) {
        this.isChat = false
        this.isChannels = false
      } else {
        this.isChannels = !this.isChannels
        if (this.isChannels) {
          console.log('Chat Widget: Load Chat Channels', this.isChannels)
          this.getChannels()
        }
      }
    },
    init() {
      if (this.pubnub === null) {
        console.log('Chat Widget: Init')
        this.initChat({ userId: this.profile.username, events: null }).then(response => {
          console.log('Chat Widget: Init Success')
          // this.getChannels()
        })
      }
    },
    async showMessages(data) {
      this.resetMessages()
      this.isChannels = false
      this.isChat = true
      this.channelId = data.calibrateEvent
      let request = {
        channelId: this.channelId,
        startIndex: 0,
        mainPageSize: 999
      }
      console.log('Chat Widget: Get Channel Info', data)
      await this.getChannelInfo(data)
      console.log('Chat Widget: Get Channel Messages', request)
      await this.getChannelMessages(request)
      if (this.channelId) {
        if (parseInt(this.channelId) > 0) {
          console.log('Chat Widget: Get Calibrate Event', this.channelId)
          await this.getCalibrateEvent({
            id: this.channelId,
            username: this.profile.username
          })
        }
      }
    }
  },
  beforeDestroy() {
    this.quitChat()
  }
}
</script>
<style lang="scss" scoped>
.custom-channels {
  position: absolute;
  z-index: 99992;
  width: 410px;
  height: 570px;
  right: 10px;
  bottom: 80px;
  overflow: hidden;
}
.custom-chat {
  position: absolute;
  z-index: 99992;
  width: 410px;
  height: 570px;
  right: 10px;
  bottom: 80px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/chat-widget.vue